import {ON_SIDEBAR_MODAL_BLUR, ON_SIDEBAR_MODAL_FOCUS, SIZE_CHANGED} from './type'

export const onSidebarModalFocus = (id, time) => {
    return {
        type: ON_SIDEBAR_MODAL_FOCUS,
        payload: {
            id,
            time,
        },
    }
}

export const onSidebarModalBlur = id => {
    return {
        type: ON_SIDEBAR_MODAL_BLUR,
        payload: id,
    }
}

export const sizeChanged = () => {
    return dispatch => {
        dispatch({
            type: SIZE_CHANGED,
            payload: {
                width: window.innerWidth,
            },
        })
    }
}
